export default [
    {
        point: '@@layers',
        prefix: '@mc-common',
        onload: function () { return require('./layers').default; },
    },
];
